/** @format */

import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef, useMemo } from 'react'
import styled from 'styled-components'
import { _$, Radio, Button, Icon, Select, Option, Dialog, Input } from '@king-design/react'
import SelectInstanceTabs from './SelectInstanceTabs'
import InstanceDialog from './InstanceDialog'
import ProjectInstanceDialog from './ProjectInstanceDialog'
import { useDeepCompareEffect } from 'react-use'
import { SelectInstanceProps, ProjectItemProp, GroupItemProps, InstanceItem } from './constants'
import ApiCommon from 'src/api/ApiCommon'
import { request } from 'src/utils'

export interface SelectInstanceHandel {
  getInstance: () => InstanceItem[] | string[] | number
  getUnbindList?: () => string[]
}

const SelectInstance = forwardRef<SelectInstanceHandel, SelectInstanceProps>(
  (
    {
      className,
      pageType,
      policyId,
      triggerRules,
      productType,
      region,
      disabled,
      allInstance = true,
      optionalInstance = true,
      IPpackage = false,
      isGroupFilter = true,
      isRegionFilter = false,
      defaultInstance = [],
      instanceIdsTotal,
      setInstaneIdsTotal,
      instanceMaxLength,
      instanceGroup = true,
      groupListProps,
      defaultGroup = null,
      projectDimens = true,
      projectDisabled = false,
      defalutProject = undefined,
      batchSearch = false,
      getSelectedInstaces,
      defaultRadioValue,
      selectContainer,
      onChange
    },
    ref
  ) => {
    // 自选类型（1:全部实例、2:项目、3:自选实例、4:实例组）
    const [radioValue, setRadioValue] = useState<number>(defaultRadioValue)
    // 自选实例弹窗
    const [optionalVisible, setOptionalVisible] = useState<boolean>(false)
    // 自选实例：选中的实例list
    const [selectedInstance, setSelectedInstance] = useState<InstanceItem[]>(defaultInstance)
    // 所有实例组
    const [groupList, setGroupList] = useState<GroupItemProps[]>([])
    // 当前选中的实例组
    const [selectedGroup, setSelectedGroup] = useState<number>(defaultGroup)
    // 所有项目
    const [projectList, setProjectList] = useState<ProjectItemProp[]>([])
    // 当前选中的项目
    const [selectedProject, setSelectedProjuect] = useState<number>(defalutProject)
    // 批量新建textarea
    const [packageValue, setPackageValue] = useState<string>('')
    // 查看选中项目实例弹窗
    const [projectInstance, setProjectInstance] = useState<boolean>(false)
    // 阈值告警ref
    const tacticsAlarmRef = useRef(null)

    useImperativeHandle(ref, () => ({
      getInstance: () => {
        if (radioValue === 2) {
          return selectedProject
        } else if (radioValue === 4) {
          return selectedGroup
        } else if (radioValue === 3) {
          return selectedInstance
        } else if (radioValue === 5) {
          return packageValue.split('\n')
        } else {
          return []
        }
      },
      getUnbindList: () => {
        return tacticsAlarmRef?.current?.getUnbindList()
      }
    }))

    useEffect(() => {
      if (radioValue === 2) {
        if (!projectList?.length) {
          getProjectList()
        }
      } else if (radioValue === 4) {
        if (!groupList?.length) {
          getGroupList()
        }
      }
    }, [radioValue])

    // 初始化已选中的实例list && 切换产品类型 过滤不属于当前产品类型的实例
    useDeepCompareEffect(() => {
      if (defaultInstance?.length) {
        const update = defaultInstance.map(item => {
          if (typeof item === 'string') {
            return { instanceId: item, instanceName: item }
          } else {
            return item
          }
        })
        setSelectedInstance(update)
      } else {
        setSelectedInstance([])
      }
    }, [productType, defaultInstance])

    // 获取项目list
    const getProjectList = async () => {
      const {
        data: {
          ListProjectResult: { ProjectList }
        }
      } = await request(ApiCommon.getAccountAllProjectList, {
        headers: {
          'X-KSC-SERVICE': 'iam'
        }
      })
      if (ProjectList?.length) {
        setProjectList(ProjectList)
      }
    }

    // 获取实例组list
    const getGroupList = async () => {
      if (Array.isArray(groupListProps)) {
        setGroupList(groupListProps)
      } else {
        const {
          data: { groupList }
        } = await request(ApiCommon.getGroupList, {
          data: {
            ProductType: productType,
            Region: region,
            PageIndex: 1,
            PageSize: 999
          }
        })
        if (groupList?.length) {
          setGroupList(groupList)
        }
      }
    }

    // 计算total
    const handleInstanceTotal = useMemo(() => {
      if (instanceIdsTotal) {
        return instanceIdsTotal
      } else {
        return selectedInstance.length
      }
    }, [instanceIdsTotal, selectedInstance])
    return (
      <div className={className}>
        <div className="instance-radio">
          {allInstance && (
            <Radio
              name="instanceRadio"
              trueValue={1}
              value={radioValue}
              disabled={disabled}
              onChangeValue={value => {
                setRadioValue(value)
                onChange && onChange(value, '*')
              }}
            >
              {_$('全部实例')}
            </Radio>
          )}
          {optionalInstance && (
            <Radio
              name="instanceRadio"
              trueValue={3}
              value={radioValue}
              disabled={disabled}
              onChangeValue={value => {
                setRadioValue(value)
                onChange && onChange(3, selectedInstance)
              }}
            >
              {_$('自选实例')}
              {radioValue === 3 ? (
                <span>
                  (
                  {
                    <span
                      className={
                        handleInstanceTotal > instanceMaxLength ? 'error-text' : 'primary-color'
                      }
                    >
                      {handleInstanceTotal}
                    </span>
                  }
                  )
                </span>
              ) : null}
            </Radio>
          )}
          {IPpackage && (
            <Radio
              name="instanceRadio"
              trueValue={5}
              value={radioValue}
              disabled={disabled}
              onChangeValue={value => {
                setRadioValue(value)
                onChange && onChange(5, packageValue)
              }}
            >
              {_$('批量新建')}
            </Radio>
          )}
          {instanceGroup && (
            <Radio
              name="instanceRadio"
              trueValue={4}
              value={radioValue}
              disabled={disabled}
              onChangeValue={value => {
                setRadioValue(value)
                onChange && onChange(4, selectedGroup)
              }}
            >
              {_$('资源分组')}
            </Radio>
          )}
          {projectDimens && (
            <Radio
              name="instanceRadio"
              trueValue={2}
              value={radioValue}
              disabled={disabled || projectDisabled}
              onChangeValue={value => {
                setRadioValue(value)
                onChange && onChange(value, selectedProject)
              }}
            >
              {_$('项目')}
            </Radio>
          )}
        </div>
        <div className="instance-body">
          {/* 全部实例 */}
          {radioValue === 1 && <p>{_$('您账户下当前全部的实例。')}</p>}
          {/* 项目 */}
          {radioValue === 2 && (
            <div className="project-dimens ksc-space">
              <Select
                filterable
                value={selectedProject}
                container={selectContainer || undefined}
                disabled={disabled || projectDisabled}
                onChangeValue={value => {
                  setSelectedProjuect(value)
                  onChange && onChange(2, value)
                }}
              >
                {projectList.map(item => (
                  <Option key={item.ProjectId} value={item.ProjectId}>
                    {item.ProjectName}
                  </Option>
                ))}
              </Select>
              {selectedProject !== undefined && getSelectedInstaces ? (
                <Button
                  type="primary"
                  onClick={() => {
                    setProjectInstance(true)
                  }}
                >
                  {_$('查看实例')}
                </Button>
              ) : null}
            </div>
          )}
          {/* 自选实例 */}
          {radioValue === 3 && (
            <div className="optional-instance">
              {pageType === 'tacticsAlarm' ? (
                <SelectInstanceTabs
                  ref={tacticsAlarmRef}
                  policyId={policyId}
                  productType={productType}
                  instanceIdsTotal={instanceIdsTotal}
                  setInstaneIdsTotal={setInstaneIdsTotal}
                  selectedInstance={selectedInstance}
                  setSelectedInstance={setSelectedInstance}
                  triggerRules={triggerRules}
                />
              ) : null}
              {pageType !== 'tacticsAlarm' ? (
                <Button
                  type="primary"
                  // disabled={disabled}
                  style={pageType === 'tacticsAlarm' ? { marginTop: '16px' } : {}}
                  onClick={() => {
                    setOptionalVisible(true)
                  }}
                >
                  <Icon className="ion-plus-round" size="small" />
                  {_$('选择实例')}
                </Button>
              ) : null}
            </div>
          )}
          {/* 实例组 */}
          {radioValue === 4 && (
            <div className="instance-group">
              <Select
                filterable
                value={selectedGroup}
                container={selectContainer || undefined}
                disabled={disabled}
                onChangeValue={value => {
                  setSelectedGroup(value)
                  onChange && onChange(4, value)
                }}
              >
                {groupList.map(item => (
                  <Option key={item.groupId} value={item.groupId}>
                    {item.groupName}
                  </Option>
                ))}
              </Select>
            </div>
          )}
          {/* 批量新建（弹性IP） */}
          {radioValue === 5 && IPpackage && (
            <div className="instance-IPpackage">
              <Input
                type="textarea"
                rows="5"
                placeholder={_$('请输入EIP，以换行分隔。')}
                value={packageValue}
                onChangeValue={value => {
                  setPackageValue(value)
                  onChange && onChange(5, value)
                }}
              />
            </div>
          )}
        </div>
        {pageType !== 'tacticsAlarm' ? (
          <Dialog
            width={900}
            value={optionalVisible}
            onChangeValue={show => {
              if (!show) {
                setOptionalVisible(false)
              }
            }}
            title={_$('自选实例')}
            slotFooter={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setOptionalVisible(false)
                    onChange && onChange(3, selectedInstance)
                  }}
                >
                  {_$('关闭')}
                </Button>
              </>
            }
          >
            <InstanceDialog
              productType={productType}
              region={region}
              visible={optionalVisible}
              selectedInstance={selectedInstance}
              instanceMaxLength={instanceMaxLength}
              setSelectedInstance={setSelectedInstance}
              isGroupFilter={isGroupFilter}
              groupListProps={groupListProps}
              isRegionFilter={isRegionFilter}
              batchSearch={batchSearch}
              disabled={disabled}
            />
          </Dialog>
        ) : null}
        <Dialog
          width={850}
          value={projectInstance}
          onChangeValue={show => {
            if (!show) {
              setProjectInstance(false)
            }
          }}
          title={_$('查看实例')}
          slotFooter={
            <>
              <Button
                type="primary"
                onClick={() => {
                  setProjectInstance(false)
                }}
              >
                {_$('关闭')}
              </Button>
            </>
          }
        >
          <ProjectInstanceDialog getSelectedInstaces={getSelectedInstaces} />
        </Dialog>
      </div>
    )
  }
)
export * from './constants'
export default styled(SelectInstance)`
  margin-top: 6px;
  .instance-radio {
    .k-radio {
      margin-right: 16px;
    }
  }
  .instance-body {
    margin-top: 16px;
  }
`
